export default __webpack_public_path__ + "static/media/ferramenta-baixar-foto-img5.2119789a.jpeg";